// extracted by mini-css-extract-plugin
export default {"container":"DropDownMenu_container__X8R0A","btn":"DropDownMenu_btn__TVZz5"};